<template>
  <div>

    <!--                      -->
    <!--UNITS (base units)-->
    <!--                      -->
    <HideableDiv>
      <template slot="buttonHidden">
        <div class="div-button heading typed-on-paper-tabs">Units</div>
      </template>
      <DivLinkButton
      class="typed-on-paper-tabs-2nd"
      v-for="unit in base_units"
      v-bind:key="unit.id"
      v-bind="{routeName: 'BaseUnitInfo', routeParams: {unit_id: unit.id}}"
      >
        <span class="heading">{{ unit.name }}</span>
      </DivLinkButton>
    </HideableDiv>

    <!--                      -->
    <!--HIST-UNITS            -->
    <!--                      -->
    <HideableDiv>
      <template slot="buttonHidden">
        <div class="div-button heading typed-on-paper-tabs">Historical Squadrons</div>
      </template>

      <div class="search-div">
        <div class="container narrow">
          <label>Search unit:</label>
          <input v-model="searchString">
        </div>
        <div
          class="div-button narrow"
          v-on:click="switchShowRAF()"
          v-bind:class="{raf: showRAF}"
        >{{ showRAFButtonText }}</div>
        <div
          class="div-button narrow"
          v-on:click="switchShowUSAAF()"
          v-bind:class="{usaaf: showUSAAF}"
        >{{ showUSAAFButtonText }}</div>
        <div
          class="div-button narrow"
          v-on:click="switchShowVVS()"
          v-bind:class="{vvs: showVVS}"
        >{{ showVVSButtonText }}</div>
        <div
          class="div-button narrow"
          v-on:click="switchShowLW()"
          v-bind:class="{luftwaffe: showLW}"
        >{{ showLWButtonText }}</div>
        <div
          class="div-button narrow"
          v-on:click="switchShowRA()"
          v-bind:class="{ra: showRA}"
        >{{ showRAButtonText }}</div>
        <div
          class="div-button narrow"
          v-on:click="switchShowFARR()"
          v-bind:class="{ra: showFARR}"
        >{{ showFARRButtonText }}</div>
		<div
          class="div-button narrow"
          v-on:click="switchShowFAF()"
          v-bind:class="{faf: showFAF}"
        >{{ showVVSButtonText }}</div>
      </div>

      <DivLinkButton
        class="unit-buttons"
        v-for="unit in hist_units_filtered"
        v-bind:class="{
        luftwaffe: (unit.faction == 1),
        raf: (unit.faction == 2),
        vvs: (unit.faction == 3),
        ra: (unit.faction == 4),
        usaaf: (unit.faction == 5),
        farr: (unit.faction == 6),
		    faf: (unit.faction == 7)}"
        v-bind:key="unit.id"
        v-bind="{routeName: 'HistUnitInfo', routeParams: {unit_id: unit.id}}"
      >
        <img class="unitEmblem" :src="unit.image"/>
        <span class="heading">{{ unit.name }}</span>
      </DivLinkButton>
    </HideableDiv>

  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import statusConv from "../../resource/statusConverter"
import DivLinkButton from "../basic_comp/DivLinkButton"
import HideableDiv from "../basic_comp/HideableDiv"

export default {
  name: "UnitInfoSideNav",
  components: {
    DivLinkButton,
    HideableDiv
  },
  mixins: [
    statusConv
  ],
  mounted () {

    this.$store.dispatch('unitInfo/loadStoreData',
      {
        caller: this.$options.name,
        call_object: {
          view: "base_unit",
        },
        data_array_name: "base_units"
      }
    ).catch(error => {
      console.log(error.message);
    });

    this.$store.dispatch('unitInfo/loadStoreData',
      {
        caller: this.$options.name,
        call_object: {
          view: "hist_unit_info",
        },
        data_array_name: "hist_units"
      }
    ).catch(error => {
      console.log(error.message);
    });

    this.$store.dispatch('unitInfo/loadStoreData',
      {
        caller: this.$options.name,
        call_object: {
          view: "rank_lookup",
        },
        data_array_name: "rank_lookup"
      }
    ).catch(error => {
      console.log(error.message);
    });
  },
  data() {
    return {

      showLW: true,
      showRAF: true,
      showVVS: true,
      showRA: true,
      showUSAAF: true,
      showFARR: true,
	  showFAF: true,
      searchString: "",
    }
  },
  computed: {

    showLWButtonText: function () {

      return this.showLW ? "Hide "+this.factionStatus[1].long : "Show "+this.factionStatus[1].long
    },

    showRAFButtonText: function () {

      return this.showRAF ? "Hide "+this.factionStatus[2].long : "Show "+this.factionStatus[2].long
    },

    showVVSButtonText: function () {

      return this.showVVS ? "Hide "+this.factionStatus[3].long : "Show "+this.factionStatus[3].long
    },

    showRAButtonText: function () {

      return this.showRA ? "Hide "+this.factionStatus[4].long : "Show "+this.factionStatus[4].long
    },

    showUSAAFButtonText: function () {

      return this.showUSAAF ? "Hide "+this.factionStatus[5].long : "Show "+this.factionStatus[5].long
    },
	showFAFButtonText: function () {

      return this.showFAF ? "Hide "+this.factionStatus[7].long : "Show "+this.factionStatus[7].long
    },

    hist_units_filtered: function () {

      let showLW = this.showLW;
      let showRAF = this.showRAF;
      let showVVS = this.showVVS;
	  let showFAF = this.showFAF;
      let showRA = this.showRA;
      let showUSAAF = this.showUSAAF;
      let showFARR = this.showFARR;
      let hist_units = this.filterByString("hist_units", "name", this.searchString);
      return hist_units.filter(
        function (unit) {
          return (
            (showLW && unit.faction === 1) ||
            (showRAF && unit.faction === 2) ||
            (showVVS && unit.faction === 3) ||
            (showRA && unit.faction === 4) ||
            (showUSAAF && unit.faction === 5) ||
            (showFARR && unit.faction === 6)  ||
            (showFAF && unit.faction === 7)
          );
        });

      return hist_units;
    },

    ...mapState('unitInfo', {
      base_units: state => state.base_units,
      hist_units: state => state.hist_units
    }),

    ...mapGetters("unitInfo", [
      "filterByKey",
      "filterByString"
    ])
  },
  methods: {

    switchShowLW: function () {
      this.showLW = !this.showLW;
    },

    switchShowRAF: function () {
      this.showRAF = !this.showRAF;
    },

    switchShowVVS: function () {
      this.showVVS = !this.showVVS;
    },

    switchShowRA: function () {
      this.showRA = !this.showRA;
    },

    switchShowUSAAF: function () {
      this.showUSAAF = !this.showUSAAF;
    },

    switchShowFARR: function () {
      this.showFARR = !this.showFARR;
    },
	switchShowFAF: function () {
      this.showFAF = !this.showFAF;
    },

  }
}
</script>

<style scoped>

.search-div{
  padding-bottom: 10px;
}

.narrow{
  font-size: 1em;
  margin: 2px 0px 0px 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  width: calc(100% - 20px - 26px);
}

.unitEmblem {
  height: 37px;
  vertical-align: middle;
}

</style>



// WEBPACK FOOTER //
// src/components/unit/UnitInfoSideNav.vue